/**
 * Marketing copy for the meal/treat cards (Figma frames 14 "pick meals" +
 * 15 "Treats"). Store products don't carry these descriptions, so they're
 * keyed here by a normalised fragment of the product title.
 */

const RECIPE_DESCRIPTIONS: [string, string][] = [
  [
    "salmon & turkey",
    "Two proteins, twice the tail wags. Omega-rich salmon meets lean turkey, with butternut, apple and a kale-broccoli boost. Our Border Collie taste-tester's favourite. Fair warning: real salmon smells like real fish. If you don't like the smell of fish, this one may not be for you.",
  ],
  [
    "lovely lamb",
    "Tender British lamb with sweet potato and garden veg, named after the Ridgeback who inspired it all. Deeply savoury, and Loki still loses his mind over it.",
  ],
  [
    "beef bowl",
    "Prime British beef with butternut, carrots and leafy greens in the recipe we spent 6 months perfecting. Hearty, rich, and the bowl that started it all.",
  ],
  [
    "veggie packed salmon",
    "Fresh salmon and flaky white fish piled high with kale, apple and garden veg. So good our 15-year-old taster Woody still inhales every bite. Fair warning: real salmon smells like real fish. If you don't like the smell of fish, this one may not be for you.",
  ],
  [
    "tasty turkey",
    "Lean British turkey with butternut, sweet apple and crunchy greens. Gentle on sensitive tummies, a knockout in the bowl.",
  ],
];

const TREAT_DESCRIPTIONS: [string, string][] = [
  [
    "venison",
    "Rich, savory venison in every bite. They're the ultimate high-reward treat that leaves the junk ingredients behind.",
  ],
  [
    "beef stick",
    "100% natural beef sticks, with no other ingredients. Turns out treats can be just as healthy as they are tasty.",
  ],
  [
    "salmon strip",
    "Packed with natural Omega-3s, these 100% pure salmon strips are irresistibly rich flavour and give a healthy boost for a brilliant, glossy coat.",
  ],
  [
    "pizzle",
    "Four premium 12cm chews, zero artificial junk. Just pure, natural beef pizzle packed with the irresistible flavour your dog lives for.",
  ],
];

function lookup(table: [string, string][], title: string | undefined): string | undefined {
  if (!title) return undefined;
  const t = title.toLowerCase();
  return table.find(([key]) => t.includes(key))?.[1];
}

export function recipeDescriptionFor(title: string | undefined): string | undefined {
  return lookup(RECIPE_DESCRIPTIONS, title);
}

export function treatDescriptionFor(title: string | undefined): string | undefined {
  return lookup(TREAT_DESCRIPTIONS, title);
}

/** Trustpilot quote shown at the top of the pick-meals screen (Figma 14). */
export const MEALS_REVIEW = {
  title: "Best dog food",
  quote:
    "Best food I could give my dog!! She absolutely loves it, bowls are spotless after a feed and her fur has never been so shiny!",
  author: "Noelia",
};
